<template>
<div class="chapter">
<div class="inner_page">
<div class="chapterHead" id="Contents">
<h2 class="chapterTitle2">Contents</h2>
</div>
<p class="contentsEntry1-TS"><a href="#/05_00_Introduction">Introduction</a></p>
<p class="contentsEntry1-BS"><a href="#/06_00_Photograph_Sources">Photograph Sources</a></p>
<p class="contentsEntry1"><a href="#/07_00_Chapter1">Chapter One</a></p>
<p class="contentsEntry"><a href="#/07_00_Chapter1">Mussolini’s Panzers</a></p>
<p class="contentsEntry1"><span href="#/08_00_Chapter2" title="Link target outside of Sample">Chapter Two</span></p>
<p class="contentsEntry"><span href="#/08_00_Chapter2" title="Link target outside of Sample">The Western Desert Force</span></p>
<p class="contentsEntry1"><span href="#/09_00_Chapter3" title="Link target outside of Sample">Chapter Three</span></p>
<p class="contentsEntry"><span href="#/09_00_Chapter3" title="Link target outside of Sample">‘Fox killed in the open’ – Beda Fomm</span></p>
<p class="contentsEntry1"><span href="#/10_00_Chapter4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="contentsEntry"><span href="#/10_00_Chapter4" title="Link target outside of Sample">East African Distraction</span></p>
<p class="contentsEntry1"><span href="#/11_00_Chapter5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="contentsEntry"><span href="#/11_00_Chapter5" title="Link target outside of Sample">The Desert Fox Arrives</span></p>
<p class="contentsEntry1"><span href="#/12_00_Chapter6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="contentsEntry"><span href="#/12_00_Chapter6" title="Link target outside of Sample">Churchill’s ‘Battleaxe’</span></p>
<p class="contentsEntry1"><span href="#/13_00_Chapter7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="contentsEntry"><span href="#/13_00_Chapter7" title="Link target outside of Sample">Crusader – Panzergruppe Afrika Driven Back</span></p>
<p class="contentsEntry1"><span href="#/14_00_Chapter8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="contentsEntry"><span href="#/14_00_Chapter8" title="Link target outside of Sample">Grant and Sherman – The Americans Are Coming!</span></p>
<p class="contentsEntry1"><span href="#/15_00_Chapter9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="contentsEntry"><span href="#/15_00_Chapter9" title="Link target outside of Sample">El Alamein – Rommel Defeated</span></p>
<p class="contentsEntry1"><span href="#/16_00_Chapter10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="contentsEntry"><span href="#/16_00_Chapter10" title="Link target outside of Sample">Kasserine – The Panzers’ Last Hurrah</span></p>
<p class="contentsEntry1"><span href="#/17_00_Chapter11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="contentsEntry"><span href="#/17_00_Chapter11" title="Link target outside of Sample">Mareth and Longstop – The Road to Tunis</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_00_Contents.vue?17c9cdfa